import { render, staticRenderFns } from "./areamanager.vue?vue&type=template&id=9f136b8c&scoped=true&"
import script from "./areamanager.vue?vue&type=script&lang=js&"
export * from "./areamanager.vue?vue&type=script&lang=js&"
import style0 from "./areamanager.vue?vue&type=style&index=0&id=9f136b8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f136b8c",
  null
  
)

export default component.exports